import { useAppDispatch, useAppSelector, useMenu } from 'src/hooks';
import { useEffect, useState } from 'react';
import { Button, Grid, IconButton, Menu } from '@mui/material';
import HighlightOffOutlinedIcon from '@mui/icons-material/HighlightOffOutlined';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import './segment-info.scss';
import Storage from 'src/utils/storage/storage';
import {
  getSegmentDetails,
  getUserGuide
} from 'src/pages/analytics/landing/store/landing-slice';
import _ from 'lodash';
import TemporaryDialog from 'src/pages/analytics/simulator/common/components/module-save-button/temporary-dialog';
import { string } from 'yup';
import moment from 'moment';

export default function SegmentInfo({ columns }: { columns: any }) {
  const appDispatch = useAppDispatch();

  const segmentDetailsStorage = Storage.getSegmentDetails();
  const { segmentDetailsData } = useAppSelector((state) => state.landing);

  const segmentDetailsDataObject = !_.isEmpty(segmentDetailsData)
    ? segmentDetailsData
    : segmentDetailsStorage !== null
      ? segmentDetailsStorage
      : {};

  useEffect(() => {
    // appDispatch(getSegmentDetails());
  }, []);

  const [isTemporaryDialogOpen, setIsTemporaryDialogOpen] = useState(false);

  // local state for menu item
  const { isMenuOpen, anchorEl, handleMenuOpen, handleMenuClose } = useMenu();

  const segmentMapObject: {
    [key: string]: {
      label: string;
      value: string;
      order: number;
      type: string;
    };
  } = {
    source_name: {
      label: 'Country x Segment applied: ',
      value: 'NL - MW',
      type: 'string',
      order: 1
    },
    currency: {
      label: 'Local Currency: ',
      value: 'Euro (€)',
      type: 'string',
      order: 2
    },
    model_refreshed_date: {
      label: 'Model Refreshed on: ',
      value: 'mm/dd/yyyy',
      type: 'date',
      order: 3
    },
    data_refreshed_date: {
      label: 'Reporting Data Refreshed on: ',
      value: 'mm/dd/yyyy',
      type: 'date',
      order: 4
    },
    sellout_data_as_of: {
      label: 'Simulator sell-out data as of: ',
      value: 'mm/dd/yyy',
      type: 'date',
      order: 5
    },
    sellin_data_as_of: {
      label: 'Simulator sell-in data as of: ',
      value: 'P06 2025',
      type: 'string',
      order: 6
    },
    support_contact: {
      label: 'Support Contact: ',
      value: 'support@effem.com',
      type: 'string',
      order: 7
    },
    exchange_rate: {
      label: 'USD Exchange Rate: ',
      value: '-',
      type: 'float',
      order: 8
    },
    rate_refreshed_date: {
      label: 'Exchange Rate Updated on: ',
      value: 'mm/dd/yyyy',
      type: 'date',
      order: 9
    },
    tool_guide: {
      label: 'Tool Guide: ',
      value: 'Click to Download',
      type: 'string',
      order: 10
    }
  };

  // Getting the keys of segment info object
  const segmentInfoKeys = Object.keys(segmentMapObject).filter(
    (key) => key in segmentDetailsDataObject
  );

  // Sorting the object keys by the "order" key
  const sortedSegmentDetails = segmentInfoKeys.sort(
    (a, b) => segmentMapObject[a]?.order - segmentMapObject[b]?.order
  );

  /**
   * handler for download user guide
   */
  const handleDownload = () => {
    appDispatch(getUserGuide())
      .then((response) => {
        console.log(response);
      })
      .catch((error) => {
        console.error('Failed to download summary', error);
        setIsTemporaryDialogOpen(true);
      });
  };

  return (
    <>
      <IconButton onClick={handleMenuOpen}>
        <InfoOutlinedIcon />
      </IconButton>
      <Menu
        id='basic-menu'
        anchorEl={anchorEl}
        open={isMenuOpen}
        onClose={handleMenuClose}
        PaperProps={{
          sx: { minWidth: '400px', border: '1px solid #0000A0' }
        }}
        sx={{ padding: '4px 0 4px 0' }}
      >
        {!_.isEmpty(segmentDetailsDataObject) ? (
          <>
            <div className='close-button-div'>
              <IconButton onClick={handleMenuClose}>
                <HighlightOffOutlinedIcon />
              </IconButton>
            </div>
            {sortedSegmentDetails.map((ele) => (
              <Grid container spacing={2} alignItems='center' ml={0} key={ele}>
                <Grid item xs={6} md={6} className='segment-info-text-left'>
                  {segmentMapObject[ele]?.label}
                </Grid>
                <Grid item xs={6} md={6} className='segment-info-text-right'>
                  {segmentDetailsDataObject[ele]
                    ? segmentMapObject[ele]?.type === 'date'
                      ? moment(segmentDetailsDataObject[ele]).format(
                        'Do MMM YYYY'
                      )
                      : segmentDetailsDataObject[ele]
                    : '-'}
                </Grid>
              </Grid>
            ))}
            <Grid container spacing={2} alignItems='center' ml={0}>
              <Grid item xs={6} md={6} className='segment-info-text-left'>
                {segmentMapObject.tool_guide.label}
              </Grid>
              <Grid item xs={6} md={6} className='segment-info-text-right'>
                <Button
                  variant='text'
                  onClick={handleDownload}
                  sx={{ paddingLeft: '0px' }}
                >
                  {segmentMapObject.tool_guide.value}
                </Button>
              </Grid>
            </Grid>
          </>
        ) : (
          'No Data Available for the segment'
        )}
      </Menu>
      {isTemporaryDialogOpen ? (
        <TemporaryDialog
          isOpen={isTemporaryDialogOpen}
          message='Failed to download user guide'
          onClose={() => {
            setIsTemporaryDialogOpen(false);
          }}
        />
      ) : null}
    </>
  );
}
